export default __webpack_public_path__ + "static/media/Nick.5b67f7a7.png";